// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat-transfer';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M14.867 9.533v3.2A1.067 1.067 0 0 1 13.8 13.8H6.333l-3.2 3.2v-3.2H2.067A1.067 1.067 0 0 1 1 12.733V4.2a1.067 1.067 0 0 1 1.067-1.067h5.866M14.867 1 17 3.133l-2.133 2.134' />
    <path d='M9.533 7.4a4.267 4.267 0 0 1 4.266-4.267H17' />
  </g>
);

export const viewBox = '0 0 18 18';
